import { render } from "./UserEditHeaderRole.vue?vue&type=template&id=21d1b099&scoped=true&ts=true"
import script from "./UserEditHeaderRole.vue?vue&type=script&lang=ts"
export * from "./UserEditHeaderRole.vue?vue&type=script&lang=ts"

import "./UserEditHeaderRole.vue?vue&type=style&index=0&id=21d1b099&scoped=true&lang=scss"

import exportComponent from "C:\\Users\\y-tosa.LOCALPSC\\repo\\seto-solan\\apps\\admin-app\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-21d1b099"]])

export default __exports__